export const prefetchCardAssets = async () => {
  await Promise.allSettled([
    import(/* webpackChunkName: "BlackCard-SVGComponent" */ './card-assets/Black'),
    import(/* webpackChunkName: "WhiteCard-SVGComponent" */ './card-assets/White'),
    import(/* webpackChunkName: "PinkCard-SVGComponent" */ './card-assets/Pink'),
    import(/* webpackChunkName: "GlowInTheDarkCard-SVGComponent" */ './card-assets/GlowInTheDark'),
    import(/* webpackChunkName: "ChameleonMetalCard-SVGComponent" */ './card-assets/ChameleonMetal'),
    import(/* webpackChunkName: "ChipCard-SVGComponent" */ './card-assets/Chip'),
    import(/* webpackChunkName: "BlackMetalCard-SVGComponent" */ './card-assets/BlackMetal'),
    import(/* webpackChunkName: "DreamCard-SVGComponent" */ './card-assets/Dream'),
    import(/* webpackChunkName: "GlitterCard-SVGComponent" */ './card-assets/Glitter'),
    import(/* webpackChunkName: "MoodCard-SVGComponent" */ './card-assets/Mood'),
    import(/* webpackChunkName: "TortoiseCard-SVGComponent" */ './card-assets/Tortoise'),
    import(/* webpackChunkName: "ShantellMartinCard-SVGComponent" */ './card-assets/ShantellMartin'),
    import(/* webpackChunkName: "HundredThievesCard-SVGComponent" */ './card-assets/HundredThieves'),
    import(/* webpackChunkName: "HoloCard-SVGComponent" */ './card-assets/Holo'),
  ])
}
